import * as types from './index';

const { rest: actions } = types;

export const setIsDisplayNav = (isResize: boolean) => (dispatch: any) => {
  dispatch(actions.resizeWindow(isResize));
};
